module.exports = {"require":"This field is required"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/validate/ENG.json
// module id = 1332
// module chunks = 121